import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=da609710&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=da609710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da609710",
  null
  
)

export default component.exports